import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`overline inline-flex items-center gap-2 ${light ? "text-sml-bronze" : "text-sml-green"} ${className}`}
  >
    <span className={`h-px w-6 ${light ? "bg-sml-bronze" : "bg-sml-green"}`} />
    {children}
  </span>
);
